export async function copyTextToClipboard(text) {
    return await navigator.clipboard.writeText(text);
}